import React, { useState } from "react";
import { Grid, useMediaQuery, CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Pagination } from "@material-ui/lab";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import moment from "moment";
import { Card, CardActions, CardContent } from "../../components/Card";
import Table from "../../components/Table";
import { useAlert } from "../../components/Alert";

const GET_PERSONALMESSAGES = gql`
  query personalMessages(
    $id: Int
    $type: PersonalMessageType
    $searchTerm: String
    $latest: Boolean
    $status: AssignmentStatus
    $pageSize: Int
    $page: Int
  ) {
    personalMessages(
      id: $id
      type: $type
      searchTerm: $searchTerm
      latest: $latest
      status: $status
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        customer {
          id
        }
        user {
          id
        }
        nameOfReservation
        reservation
        content
        createdAt
        updatedAt
      }
    }
  }
`;

export default function ReservationOnlyReadTable() {
  const Alert = useAlert();
  const history = useHistory();
  const isPhone = useMediaQuery("(max-width:576px)");
  const [newData, setNewData] = useState({
    page: 1,
  });
  const { data, loading } = useQuery(GET_PERSONALMESSAGES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      id: Number(localStorage.getItem("@fullhouseUserId")),
      type: "RESERVATION",
      latest: true,
      pageSize: 10,
      page: newData.page,
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Table
            data={data ? data.personalMessages.contents : []}
            tableWidth={isPhone ? 3 : 2}
            header={["客戶姓名", "預約日期", "追蹤內容"]}
            columns={[
              (item) => item.nameOfReservation,
              (item) => moment(item.reservation).format("yyyy-MM-DD a HH:mm"),
              (item) => item.content,
            ]}
            onPress={(item) => {
              if (item.customer)
                localStorage.setItem("@fullhouseCustomer", item.customer.id);
              else localStorage.setItem("@fullhouseCustomer", item.user.id);

              history.replace("/console/customer-center");
            }}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                Boolean(data) && data.personalMessages.pageCount
                  ? data.personalMessages.pageCount
                  : 1
              }
              size="large"
              color="primary"
              page={newData.page}
              onChange={(e, n) => {
                changeData("page", n, true);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
